import React from "react";
import styled from "styled-components";

const MainDiv = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  margin: 2em 3em 2em 3em;
  height: 70vh;
`;

const ContentDiv = styled.div``;

const Title = styled.h2``;

const Paragraph = styled.p``;

function CookiePolicy() {
  return (
    <MainDiv>
      <ContentDiv>
        <Title>Cookies policy</Title>
        <Paragraph>
          Our websites use cookies to collect data, including the location of
          the devices used to access our websites as these data are integral to
          the efficient and effective operation of our websites. We use the data
          to customise the service offering. Your internet browser will usually
          allow you to disable cookies, but this may adversely affect the smooth
          operation of our website. <br />
          We have a legal duty to tell you how we store the information we
          collect and how it is used. Any information you do submit will be
          stored securely and will never be passed on or sold to any third
          party. Please see our{" "}
          <a href="/hairQ/privacy-policy">privacy policy.</a> <br />
          By using this website, you agree to our Cookie Policy and Terms of
          Service.
        </Paragraph>
      </ContentDiv>
    </MainDiv>
  );
}

export default CookiePolicy;
